// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3exdrdVRtD27WsM1CndKd6","container":"EjhM-fvT_JiDy4h8187xD","logo":"_3tWtLuK64nLAw8fy2YQ2PA","logo-initials":"_3g5DIlan_3_U9BsK-BXgMf","logoInitials":"_3g5DIlan_3_U9BsK-BXgMf","logo-name":"_1Pd2YoZG-Mze0YFp-PedXu","logoName":"_1Pd2YoZG-Mze0YFp-PedXu","logoTitle":"ChtirTBWWDs6Ph4fIIwUI","logo-subname":"_1Ni39LZ3tx1RpmQ0CRiP0X","logoSubname":"_1Ni39LZ3tx1RpmQ0CRiP0X"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/LogoSmall/styles.scss
 ** module id = 528
 ** module chunks = 0
 **/